import {fork} from 'redux-saga/effects'; 
import userSaga from './User';
import configSaga from './Config';
import profileSaga from './Profile';
import plansSaga from './Plans';
import contentSaga from "./Contents";
import firebaseSaga from './Firebase';


export default function* rootSaga() {
    yield fork( userSaga );
    yield fork( configSaga );
    yield fork( profileSaga );
    yield fork( plansSaga );
    yield fork( contentSaga );
    yield fork( firebaseSaga ); 
}



